import { useState, useEffect } from "react";


const initialState = {
  personal: {},
  address: {},
  identity: {},
  documents: {},
  application: {},
};

const usePassportForm = () => {

  const [formData, setFormData] = useState(() => {

    const saved = localStorage.getItem("passportForm");

    return saved
      ? JSON.parse(saved)
      : initialState;

  });


  const [status, setStatus] = useState(null);


  // ─────────────────────────────────────────────
  // Update Form
  // ─────────────────────────────────────────────

  const updateForm = (section, data) => {

    const updated = {
      ...formData,
      [section]: data,
    };

    setFormData(updated);


    // remove file object for localStorage
    const cleanData = { ...data };

    Object.keys(cleanData).forEach((key) => {

      if (cleanData[key] instanceof File) {

        cleanData[key] = {
          name: cleanData[key].name,
          size: cleanData[key].size,
        };

      }

    });


    const storageData = {
      ...formData,
      [section]: cleanData,
    };


    localStorage.setItem(
      "passportForm",
      JSON.stringify(storageData)
    );

  };


  // ─────────────────────────────────────────────
  // Submit Form
  // ─────────────────────────────────────────────

  const submitForm = () => {

    const finalData = {

      ...formData,

      status: "Under Review",

      submittedAt: new Date(),

    };

    console.log("Send to API", finalData);


    setStatus({
      status: "Under Review",
      appointmentDate: null,
    });


    // Clear Form After Submit
    clearForm();

  };


  // ─────────────────────────────────────────────
  // Clear Form
  // ─────────────────────────────────────────────

  const clearForm = () => {

    setFormData(initialState);

    localStorage.removeItem("passportForm");

  };


  // ─────────────────────────────────────────────
  // Load Saved Form
  // ─────────────────────────────────────────────

  useEffect(() => {

    const saved = localStorage.getItem("passportForm");

    if (saved) {

      setFormData(JSON.parse(saved));

    }

  }, []);


  return {

    formData,

    updateForm,

    submitForm,

    clearForm,

    status,

  };

};

export default usePassportForm;

// const usePassportForm = () => {

//   const [formData, setFormData] = useState(() => {
//     const saved = localStorage.getItem("passportForm");

//     return saved
//       ? JSON.parse(saved)
//       : {
//           personal: {},
//           address: {},
//           identity: {},
//           documents: {},
//           application: {},
//         };
//   });

//   const [status, setStatus] = useState(null);


//   const updateForm = (section, data) => {

//     // remove file object for localStorage
//     const cleanData = { ...data };

//     Object.keys(cleanData).forEach(key => {
//       if (cleanData[key] instanceof File) {
//         cleanData[key] = {
//           name: cleanData[key].name,
//           size: cleanData[key].size
//         };
//       }
//     });

//     const updated = {
//       ...formData,
//       [section]: data, // keep original in state
//     };

//     setFormData(updated);

//     // save clean version to localStorage
//     const storageData = {
//       ...formData,
//       [section]: cleanData,
//     };

//     localStorage.setItem(
//       "passportForm",
//       JSON.stringify(storageData)
//     );
//   };


//   const submitForm = () => {

//     const finalData = {
//       ...formData,
//       status: "Under Review",
//       submittedAt: new Date(),
//     };

//     console.log("Send to API", finalData);

//     setStatus({
//       status: "Under Review",
//       appointmentDate: null,
//     });

//     localStorage.removeItem("passportForm");
//   };


//   return {
//     formData,
//     updateForm,
//     submitForm,
//     status,
//   };
// };

// export default usePassportForm;